import { projectsGrid, postProjectTypes, updateProjectTypes, targetProjectTypes } from './interfaces';
import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export const getProjects = async (showCompleted: boolean, showDeleted: boolean): Promise<projectsGrid[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get<projectsGrid[]>(`https://${apiURL}/Projects`, {
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const projectData: projectsGrid[] = response.data.map((item) => ({
      projectId: item.projectId,
      client: item.client,
      description: item.description,
   }));
   return projectData;
};

export const getTargetProject = async (projectId: number): Promise<targetProjectTypes> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Projects/${projectId}`, {
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data: targetProjectTypes = response.data;

   const targetProjectData: targetProjectTypes = {
      projectId: data.projectId,
      client: {
         clientId: data.client.clientId,
         clientName: data.client.clientName,
         accountRef: data.client.accountRef,
         contactName: data.client.contactName,
         phone: data.client && data.client.phone ? data.client.phone : 'No phone number',
         email: data.client && data.client.email ? data.client.email : 'No email address',
      },
      description: data.description,
   };

   return targetProjectData;
};

export const submitProject = async (project: postProjectTypes) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Projects`,
      method: 'post',
      data: {
         clientId: project.clientId,
         description: project.description,
      },
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data: postProjectTypes = response.data;
   return data;
};

export const updateProject = async (project: updateProjectTypes, projectId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Projects/${projectId}`,
      method: 'put',
      data: {
         projectId: projectId,
         clientId: project.clientId,
         description: project.description,
      },
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data: updateProjectTypes = response.data;
   return data;
};


export const completeProject = async (projectId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Projects/MarkAsComplete/${projectId}`,
      method: 'put',
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data = response.data;

   return data;
};

export const deleteProject = async (projectId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Projects/${projectId}`,
      method: 'delete',
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data = response.data;

   return data;
};
